import { useFormik } from 'formik';

export default function usePracticeSupportFormik(initialValues = {}, onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      consultantId: initialValues.consultantId ?? '',
      onboardingArchitectId: initialValues?.onboardingArchitectId ?? '',
      insideRepresentativeId: initialValues?.insideRepresentativeId ?? '',
      region: initialValues?.region ?? '',
      medbillBuiltInBiller: initialValues?.medbillBuiltInBiller ?? null,
      medbillVirtualOfficeManager: initialValues?.medbillVirtualOfficeManager ?? null,
      generalNote: initialValues?.generalNote ?? ''
    },
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit
  });

  return formik;
}
